export default __webpack_public_path__ + "static/Driver-5be90dfd2a103ec55518a2397a7b6fa8.png";